import type { ExtendedFeaturesDownloadDto } from 'api/src/core/schemas/ProductSchema';
import { makeAutoObservable } from 'mobx';
import extractValue, {
  type EventOrValue,
} from '../../../../../../store/utils/extractValue';
import { errorHandler } from '../../../../../../utils/errors';

export type { ExtendedFeaturesDownloadDto };

export default class Download {
  text = '';

  constructor(
    dto: ExtendedFeaturesDownloadDto | undefined,
    private readonly onSave: (download: Download) => Promise<void>,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });

    this.text = dto?.text || '';
  }

  handleChange(e: EventOrValue) {
    const { name, value } = extractValue(e);
    Object.assign(this, { [name]: value });
    this.save();
  }

  save() {
    this.onSave(this).catch(errorHandler('Cannot save download message'));
  }

  toJSON(): ExtendedFeaturesDownloadDto | undefined {
    const text = this.text.trim();

    if (!text) {
      return undefined;
    }

    return { text };
  }
}
